import type { Player } from "../types";

/** Price of the first training course; every next course doubles it. */
export const TRAINING_BASE_COST = 1500;

/** Skill points granted per course. */
export const TRAINING_POINTS = 1;

/**
 * Cost of the next course given how many were already bought (canon addendum
 * 2026-09-09: money sink that converts surplus cash into scarce skill points).
 */
export function trainingCost(bought: number): number {
  return TRAINING_BASE_COST * 2 ** Math.max(0, bought);
}

export function canBuyTraining(player: Player, bought: number): boolean {
  return player.money >= trainingCost(bought);
}

/**
 * Returns a new player with the course price deducted and a skill point added,
 * or the input player unchanged when unaffordable.
 */
export function applyTraining(player: Player, bought: number): Player {
  if (!canBuyTraining(player, bought)) {
    return player;
  }
  return {
    ...player,
    money: player.money - trainingCost(bought),
    skillPoints: player.skillPoints + TRAINING_POINTS,
  };
}
